import type { ReceiptReviewChange, TransactionReceiptEdit } from "../../types/receipt";
import { startReceiptSplit } from "../../lib/receipt-splits";

/** Small serializer kept separate so edit recovery does not eagerly load receipt setup. */
export function receiptReviewChange(edit: TransactionReceiptEdit): ReceiptReviewChange {
  return { id: edit.original.id, expectedRevision: edit.revision,
    categorySplit: edit.draft.categorySplit || startReceiptSplit(edit.draft, edit.draft.expense),
    itemTotals: Object.fromEntries(edit.draft.items.map(item => [item.id, item.total])) };
}
